// these are all the dependency related keys used in no-code entities
// dependsOn is generated by buildDependencyGraph and others are generated by handlers
export const NoCodeDependencyKeys = {
  DependsOn: 'dpOn',
  DynamicPaths: 'dP',
  ConditionalPaths: 'cP',
};

// These dependency keys are omitted when serializing entities
// since they are computed/generated values rather than source data
export const DEPENDENCY_KEYS_TO_OMIT_DURING_SERIALIZATION = [
  NoCodeDependencyKeys.DynamicPaths,
  NoCodeDependencyKeys.ConditionalPaths,
  NoCodeDependencyKeys.DependsOn,
];

// when we get this const in the path of dependsOn, we know that we depend on the entire entity
export const ENTIRE_ENTITY = '*';

/**
 * Checks if a dependency represents complete dependency on an entity.
 * Complete dependency can be represented as:
 * 1. '*' in the properties array
 * 2. 'entityId['*']' in the properties array
 */
export function isCompleteDependency(entityId: string, properties: string[]): boolean {
  return (
    properties.includes(ENTIRE_ENTITY) ||
    properties.some((property) => property === `${entityId}['*']`)
  );
}
